<template>
  <b-navbar class="d-flex w-100 pr-0 mr-0 ml-0" toggleable="ipad" type="light">
    <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
    <b-navbar variant="faded" type="light">
      <b-navbar-brand>
        <router-link :to="{name: 'home'}">
          <SVGLogo class="logo_medika_xs d-block d-sm-none" />
        </router-link>
      </b-navbar-brand>
    </b-navbar>
    <b-collapse is-nav id="nav_collapse" class="w-50">
      <!-- Right aligned nav items -->
      <b-navbar-nav class="ml-auto text-center">
        <VLangSelector class="separator pr-2" />

        <CategoriesNavItemDropdown
          class="d-md-none font-weight-semibold"
          :categories="categoriesTree"
        />

        <b-nav-item class="pl-3">
          {{ deviceCountry || '' }}
        </b-nav-item>

        <b-nav-item
          class="ml-3 font-weight-semibold small-separator"
          :to="{ name: 'site_contact' }"
        >{{ $t('navigation_bar.contact') }}</b-nav-item>

        <b-nav-item
          v-if="authenticated && !getUuidPatientSelected"
          class="mr-3 ml-3 font-weight-semibold small-separator"
          :to="{ name: 'patientdata'}"
        >{{ current_username }}</b-nav-item>

        <b-nav-item
          v-if="authenticated && getUuidPatientSelected"
          class="mr-3 ml-3 font-weight-semibold small-separator"
          :to="{ name: 'userhome', params: {pt_uuid: getUuidPatientSelected} }"
        >{{ getNamePatientSelected }}</b-nav-item>

        <b-nav-item
          v-if="authenticated"
          class="mr-3 pr-3 separator font-weight-semibold small-separator"
          @click="signOut"
        >{{ $t('navigation_bar.logout') }}</b-nav-item>

        <b-nav-item
          v-if="!authenticated"
          class="mr-3 ml-3 font-weight-semibold small-separator"
          :to="{ name: 'login' }"
        >{{ $t('navigation_bar.access') }}</b-nav-item>

        <b-nav-item
          v-if="!authenticated"
          class="pr-3 separator font-weight-semibold small-separator"
          :to="{ name: 'register' }"
        >{{ $t('navigation_bar.register') }}</b-nav-item>

        <ShoppingCart class="pr-3" />

        <b-nav-item class="buy" :to="{ name: 'cart_review' }">{{ $t('navigation_bar.buy') }}</b-nav-item>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
import SVGLogo from "@/static/logo_global_store.svg";
import { mapGetters } from "vuex";
import { mapState } from "vuex";
import VLangSelector from "@/components/LanguageSelector";
import ShoppingCart from "@/components/ShoppingCart";
import CategoriesNavItemDropdown from "@/components/navigation/CategoriesNavItemDropdown";

export default {
  name: "navigation-bar",
  components: {
    VLangSelector,
    ShoppingCart,
    SVGLogo,
    CategoriesNavItemDropdown,
  },
  data() {
    return {
      activeIndex: null,
      defaultOpeneds: [],
    };
  },
  computed: {
    ...mapGetters("naturalperson", [
      "getUuidPatientSelected",
      "getNamePatientSelected",
    ]),
    ...mapGetters("drugs", ["categoriesTree"]),
    ...mapGetters("auth", ["deviceCountry"]),
    ...mapState({
      authenticated: (state) => state.auth.authenticated,
      current_username: (state) => state.auth.current_username,
      current_user_email: (state) => state.auth.current_user_email,
      patientSelected: (state) => state.naturalperson.patientSelected,
    }),
  },
  fallbackI18n: {
    messages: {
      und: {
        navigation_bar: {
          access: "Access",
          register: "Register",
          contact: "Contact",
          notifications: "Notifications",
          logout: "Logout",
          cart_name: "Cart",
          buy: "Buy",
        },
      },
    },
  },
  methods: {
    routeToLogin() {
      this.$router.push({
        name: "home",
      });
    },
    signOut() {
      this.$store.dispatch("auth/LOGOUT");
      this.$store.commit("naturalperson/MUTATE_DOCTORS", []);
      this.$store.commit("naturalperson/MUTATE_PATIENTS", []);
      this.$store.commit("shoppingcart/MUTATE_CART", {});
      this.routeToLogin();
    },
  },
};
</script>

<style lang="scss" scoped>
.navbar-light > .navbar-collapse > .navbar-nav > li > ::v-deep .nav-link {
  text-transform: uppercase;
  text-align: center;
  font-size: $font-size-small;
}

.navbar-nav > li:last-child a {
  color: $white;
}

.small-separator:before {
  content: "·";
  float: left;
  font-size: $font-size-base * 2;
  line-height: 2rem;
  color: $corp-color1;
  margin-left: -0.7rem;
}

.logo_medika_xs {
  height: 3rem;
}

.buy a {
  background-color: $nav-bar-lang-focus-bg-color;
  font-weight: bold;
}

@include media-breakpoint-up(md) {
  .separator {
    border-right: 1px solid $nav-bar-langs-divider-color;
  }
}

@include media-breakpoint-down(md) {
  .small-separator:before {
    content: "";
  }
}
</style>
